import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyModule, registerLazyOrchestrator } from "owa-bundling";
import { onOpenProfileEditor } from "owa-nova-actions";
import { getStore } from "./store/store";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "OwaNovaProfileEditor" */ "./lazyIndex"), { name: "OwaNovaProfileEditor" });

registerLazyOrchestrator(onOpenProfileEditor, lazyModule, m => m.openProfileEditor);

export const ProfileEditorAsync: typeof lazyIndex.ProfileEditorWrapper = createLazyComponent(lazyModule, m => m.ProfileEditorWrapper, undefined, undefined, {
    onlyImportIf: () => getStore().isVisible,
});
